import React from "react";
import BottomNav from "./BottomNav";

export default function Layout({ children }) {
  return (
    <div className="sg-app">
      {children}
      <BottomNav />
    </div>
  );
}
